/**
 * The subjects the app is built around. Their ids are fixed server-side, so they are
 * named here rather than repeated as literals at every call site.
 */
export const THEORY_SUBJECT_ID = 'cb8a5eb4-4f7c-4cf6-b7fb-073bdfa76737';

export const APTITUDE_SUBJECT_ID = '63a0be75-65d1-4576-8925-191a546b3d34';

export const ENGLISH_SUBJECT_ID = 'fad6092b-5a08-4542-bc9a-f3a118b99041';
